/* eslint-disable radix, no-confusing-arrow */
import {
  concat,
  merge, propEq, reject,
  compose, over, lensPath
} from 'ramda';

import {
  SUCCESS,
  FAIL,
  REQUEST,
  OPTIONS_SUCCESS,
  FAIL_DEPARTMENT_BY_JOB,
  REQUEST_DEPARTMENT_BY_JOB,
  SUCCESS_DEPARTMENT_BY_JOB,
  FAIL_JOB_INTO_DEPARTMENT,
  REQUEST_JOB_INTO_DEPARTMENT,
  SUCCESS_JOB_INTO_DEPARTMENT,
  DELETE_JOB_FROM_DEPARTMENT_FAIL,
  DELETE_JOB_FROM_DEPARTMENT_REQUEST,
  DELETE_JOB_FROM_DEPARTMENT_SUCCESS,
  LOAD_WORK_EFFORT_TYPES_FAIL,
  LOAD_WORK_EFFORT_TYPES_REQUEST,
  LOAD_WORK_EFFORT_TYPES_SUCCESS,
  PUT_JOB_FAIL,
  PUT_JOB_REQUEST,
  PUT_JOB_SUCCESS,
  DELETE_JOB_SUCCESS,
  DELETE_JOB_REQUEST,
  DELETE_JOB_FAIL,
  POST_JOB_FAIL,
  POST_JOB_SUCCESS,
  POST_JOB_REQUEST,
  LOAD_JOBS_BY_DEPARTMENT_ID_REQUEST,
  LOAD_JOBS_BY_DEPARTMENT_ID_SUCCESS,
  LOAD_JOBS_BY_DEPARTMENT_ID_FAIL,
  PUT_JOBS_MULTIPLE_SUCCESS,
  PUT_JOBS_MULTIPLE_REQUEST,
  PUT_JOBS_MULTIPLE_FAIL,
  DELETE_JOBS_USERS_MULTIPLE_REQUEST,
  DELETE_JOBS_USERS_MULTIPLE_SUCCESS,
  DELETE_JOBS_USERS_MULTIPLE_FAIL,
  DELETE_JOBS_DEPARTMENTS_MULTIPLE_REQUEST,
  DELETE_JOBS_DEPARTMENTS_MULTIPLE_SUCCESS,
  DELETE_JOBS_DEPARTMENTS_MULTIPLE_FAIL,
  POST_JOBS_DEPARTMENTS_MULTIPLE_REQUEST,
  POST_JOBS_DEPARTMENTS_MULTIPLE_SUCCESS,
  POST_JOBS_DEPARTMENTS_MULTIPLE_FAIL,
  GET_JOBS_CONDITIONAL_DELETE_REQUEST,
  GET_JOBS_CONDITIONAL_DELETE_SUCCESS,
  GET_JOBS_CONDITIONAL_DELETE_FAIL,
  LOAD_JOB_SWAPS_SUCCESS,
  POST_JOB_SWAP_SUCCESS,
  DELETE_JOB_SWAP_SUCCESS,
  ERASE_JOBS_IN_DEPARTMENT,
  LOAD_JOB_REPLACES_SUCCESS,
  POST_JOB_REPLACE_SUCCESS,
  DELETE_JOB_REPLACE_SUCCESS,
  LOAD_JOB_REPLACES_REQUEST,
  LOAD_JOB_REPLACES_FAIL,
  LOAD_PLANNED_ABSENCES_SUCCESS,
  LOAD_PLANNED_ABSENCES_REQUEST,
  LOAD_PLANNED_ABSENCES_FAIL,
  POST_PLANNED_ABSENCE_SUCCESS,
  DELETE_PLANNED_ABSENCE_SUCCESS
} from 'src/store/actions/jobActions';

const initialState = {
  list: [],
  departmentsForSpecificJob: [],
  workEffortTypes: [],
  jobProfiles: [],
  options: [],
  fetching: false,
  multipleFetching: false,
  errors: [],
  jobsForSpecificDepartment: { departmentId: -1, list: [] },
  jobsConditionalDeleteFetching: false,
  jobsConditionalDelete: [],
  jobSwaps: [],
  jobReplacesFetching: false,
  jobReplaces: [],
  plannedAbsences: [],
  plannedAbsencesFetching: false
};

const addOrMergeInList = (filter, prop, list) => list.map((item) => item[prop] === filter[prop] ? { ...item, ...filter } : item);

const jobsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true });
    case SUCCESS:
      return merge(state, { list: action.jobs, fetching: false });
    case OPTIONS_SUCCESS:
      return merge(state, { options: action.jobs });
    case FAIL:
      return merge(state, { errors: action.error, fetching: false });
    case LOAD_WORK_EFFORT_TYPES_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_WORK_EFFORT_TYPES_SUCCESS:
      return merge(state, { workEffortTypes: action.workEffortTypes, fetching: false });
    case LOAD_WORK_EFFORT_TYPES_FAIL:
      return merge(state, { errors: action.error, fetching: false });
    case REQUEST_DEPARTMENT_BY_JOB:
      return merge(state, { fetching: true });
    case SUCCESS_DEPARTMENT_BY_JOB:
      return merge(state, {
        departmentsForSpecificJob: action.departments,
        fetching: false
      });
    case FAIL_DEPARTMENT_BY_JOB:
      return merge(state, { errors: action.error, fetching: false });
    case REQUEST_JOB_INTO_DEPARTMENT:
      return merge(state, { fetching: true, errors: [] });
    case SUCCESS_JOB_INTO_DEPARTMENT: {
      const pushedJob = state.list.filter(({ JobId }) => `${JobId}` === action.payload.JobId);
      return compose(
        over(lensPath(['departmentsForSpecificJob']), concat([action.payload])),
        merge(state)
      )({
        jobsForSpecificDepartment: {
          ...state.jobsForSpecificDepartment,
          list: pushedJob.concat(state.jobsForSpecificDepartment.list)
        },
        fetching: false,
        errors: []
      });
    }
    case FAIL_JOB_INTO_DEPARTMENT:
      return merge(state, { fetching: false, errors: [action.error] });
    case ERASE_JOBS_IN_DEPARTMENT:
      return merge(state, { jobsForSpecificDepartment: { ...initialState.jobsForSpecificDepartment } });
    case DELETE_JOB_FROM_DEPARTMENT_REQUEST:
      return merge(state, { fetching: true });
    case DELETE_JOB_FROM_DEPARTMENT_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case DELETE_JOB_FROM_DEPARTMENT_SUCCESS: {
      const jobId = parseInt(action.jobId);
      const departmentId = parseInt(action.departmentId);
      const selectedDepartmentId = state.jobsForSpecificDepartment.departmentId;
      let newLobsForSpecificDepartmentList = state.jobsForSpecificDepartment.list;
      const newDepartments = reject(propEq('DepartmentId', departmentId), state.departmentsForSpecificJob);

      if (selectedDepartmentId !== '-1' && !newDepartments.filter(propEq('DepartmentId', +selectedDepartmentId)).length) {
        newLobsForSpecificDepartmentList = reject(propEq('JobId', jobId), state.jobsForSpecificDepartment.list);
      }

      return merge(state, {
        errors: [],
        fetching: false,
        departmentsForSpecificJob: newDepartments,
        jobsForSpecificDepartment: {
          ...state.jobsForSpecificDepartment,
          list: newLobsForSpecificDepartmentList
        }
      });
    }
    case DELETE_JOB_REQUEST:
      return merge(state, { fetching: true });
    case DELETE_JOB_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case DELETE_JOB_SUCCESS:
      return merge(state, {
        errors: [],
        fetching: false,
        list: reject(propEq('JobId', parseInt(action.jobId)), state.list),
        options: reject(propEq('value', action.options.value), state.options)
      });
    case PUT_JOB_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case PUT_JOB_SUCCESS:
      return merge(state, {
        fetching: false,
        errors: [],
        list: addOrMergeInList(action.job, 'JobId', state.list),
        options: addOrMergeInList(action.options, 'value', state.options),
        jobsForSpecificDepartment: {
          ...state.jobsForSpecificDepartment,
          list: addOrMergeInList(action.job, 'JobId', state.jobsForSpecificDepartment.list)
        }
      });
    case PUT_JOB_FAIL:
      return merge(state, { errors: action.error, fetching: false });
    case PUT_JOBS_MULTIPLE_REQUEST:
      return merge(state, { multipleFetching: true, errors: [] });
    case PUT_JOBS_MULTIPLE_SUCCESS:
      return merge(state, { multipleFetching: false, errors: [] });
    case PUT_JOBS_MULTIPLE_FAIL:
      return merge(state, { errors: action.error, multipleFetching: false });
    case POST_JOBS_DEPARTMENTS_MULTIPLE_REQUEST:
      return merge(state, { multipleFetching: true, errors: [] });
    case POST_JOBS_DEPARTMENTS_MULTIPLE_SUCCESS:
      return merge(state, { multipleFetching: false, errors: [] });
    case POST_JOBS_DEPARTMENTS_MULTIPLE_FAIL:
      return merge(state, { errors: action.error, multipleFetching: false });
    case DELETE_JOBS_USERS_MULTIPLE_REQUEST:
      return merge(state, { multipleFetching: true, errors: [] });
    case DELETE_JOBS_USERS_MULTIPLE_SUCCESS:
      return merge(state, { multipleFetching: false, errors: [] });
    case DELETE_JOBS_USERS_MULTIPLE_FAIL:
      return merge(state, { errors: action.error, multipleFetching: false });
    case DELETE_JOBS_DEPARTMENTS_MULTIPLE_REQUEST:
      return merge(state, { multipleFetching: true, errors: [] });
    case DELETE_JOBS_DEPARTMENTS_MULTIPLE_SUCCESS:
      return merge(state, { multipleFetching: false, errors: [] });
    case DELETE_JOBS_DEPARTMENTS_MULTIPLE_FAIL:
      return merge(state, { errors: action.error, multipleFetching: false });
    case POST_JOB_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case POST_JOB_SUCCESS:
      return merge(state, {
        options: concat(state.options, action.options),
        list: concat(state.list, action.data),
        fetching: false,
        errors: []
      });
    case POST_JOB_FAIL:
      return merge(state, { fetching: false, errors: [action.error] });
    case LOAD_JOBS_BY_DEPARTMENT_ID_REQUEST:
      return merge(state, { fetching: true, errors: [] });
    case LOAD_JOBS_BY_DEPARTMENT_ID_SUCCESS:
      return merge(state, { jobsForSpecificDepartment: action.payload, fetching: false, errors: [] });
    case LOAD_JOBS_BY_DEPARTMENT_ID_FAIL:
      return merge(state, { fetching: false, errors: [action.error], jobsForSpecificDepartment: initialState.jobsForSpecificDepartment });
    case GET_JOBS_CONDITIONAL_DELETE_REQUEST:
      return ({ ...state, jobsConditionalDeleteFetching: true });
    case GET_JOBS_CONDITIONAL_DELETE_SUCCESS:
      return ({ ...state, jobsConditionalDeleteFetching: false, jobsConditionalDelete: action.data });
    case GET_JOBS_CONDITIONAL_DELETE_FAIL:
      return ({ ...state, jobsConditionalDeleteFetching: false });
    case LOAD_JOB_SWAPS_SUCCESS:
      return ({ ...state, jobSwaps: action.payload });
    case POST_JOB_SWAP_SUCCESS:
      return ({ ...state, jobSwaps: state.jobSwaps.concat(action.payload) });
    case DELETE_JOB_SWAP_SUCCESS:
      return ({ ...state, jobSwaps: state.jobSwaps.filter((swap) => swap.Id !== action.payload) });
    case LOAD_JOB_REPLACES_REQUEST:
      return ({ ...state, jobReplacesFetching: true });
    case LOAD_JOB_REPLACES_SUCCESS:
      return ({ ...state, jobReplacesFetching: false, jobReplaces: action.payload });
    case LOAD_JOB_REPLACES_FAIL:
      return ({ ...state, jobReplacesFetching: false });
    case POST_JOB_REPLACE_SUCCESS:
      return ({ ...state, jobReplaces: state.jobReplaces.concat(action.payload) });
    case DELETE_JOB_REPLACE_SUCCESS:
      return ({ ...state, jobReplaces: state.jobReplaces.filter((jobReplace) => jobReplace.Id !== action.payload) });
    case LOAD_PLANNED_ABSENCES_REQUEST:
      return ({ ...state, plannedAbsencesFetching: true });
    case LOAD_PLANNED_ABSENCES_SUCCESS:
      return ({ ...state, plannedAbsencesFetching: false, plannedAbsences: action.payload });
    case LOAD_PLANNED_ABSENCES_FAIL:
      return ({ ...state, plannedAbsencesFetching: false });
    case POST_PLANNED_ABSENCE_SUCCESS:
      return ({ ...state, plannedAbsences: state.plannedAbsences.concat(action.payload) });
    case DELETE_PLANNED_ABSENCE_SUCCESS:
      return ({ ...state, plannedAbsences: state.plannedAbsences.filter((plannedAbsenceId) => plannedAbsenceId !== action.payload) });
    default:
      return state;
  }
};

export default jobsReducer;
